import * as React from "react";
import { useBulkSetOwnerForSecurityEvents } from "security-app/hooks/useSecurityEventsAPI";
import UsersModal from "security-app/components/SecurityEvents/Alerts/AlertsModals/UsersModal/UsersModal";
import useSendEventActionTelemetry from "components/events/events/hooks/useSendEventActionTelemetry";
import useRefetchTable from "security-app/components/SecurityEvents/Alerts/AlertsModals/UsersModal/useRefetchTable";
const SetOwnerBulk = ({ eventIds, onClose, show }) => {
  const { setOwner, settingOwners } = useBulkSetOwnerForSecurityEvents();
  const sendEventActionTelemetry = useSendEventActionTelemetry();
  const refetch = useRefetchTable();
  const onConfirm = async (ownerId) => {
    await setOwner({ ids: eventIds, ownerId });
    sendEventActionTelemetry("SET_OWNER", true);
    refetch();
    onClose();
  };
  return /* @__PURE__ */ React.createElement(
    UsersModal,
    {
      confirmDisabled: settingOwners,
      closeModal: onClose,
      onConfirm,
      show,
      isLoading: settingOwners
    }
  );
};
export default SetOwnerBulk;
